import { NotImplementedError } from './defaultErrors.js';
class BaseService {
    unimplemented(..._args) {
        throw new NotImplementedError();
    }
}
export default BaseService;
//# sourceMappingURL=BaseService.js.map